import React, { useCallback, useImperativeHandle, useState } from 'react'
import { Chip } from '@material-ui/core'
import dayjs from 'dayjs'
import RoundedModal from '../../../molecules/RoundedModal'
import SydButton from '../../../commonDesign/Button'
import SydModalActions from '../../../commonDesign/SydModal/SydModalActions'

const InvocationDetailDialog = React.forwardRef(function InvocationDetailDialog (_props, ref) {
  const [state, setState] = useState({ open: false, invocation: null })

  const close = useCallback(() => {
    setState({ open: false, invocation: null })
  }, [])

  useImperativeHandle(ref, () => ({
    open: (invocation) => setState({ open: true, invocation })
  }), [])

  const inv = state.invocation

  return (
    <RoundedModal
      title='Invocation Detail'
      open={state.open}
      onClose={close}
      size='large'
      position='top'
      disablePortal={false}
    >
      <div>
        {inv && (
          <>
            <div style={{ display: 'grid', gridTemplateColumns: '120px 1fr', gap: '0.5rem 1rem', marginBottom: '1rem' }}>
              <strong>Schedule</strong>
              <span>{inv.scheduleName || inv.scheduleCode || `#${inv.scheduleId}`}</span>

              <strong>Fired At</strong>
              <span>{dayjs(inv.firedAt).format('MMM D, YYYY h:mm:ss A')}</span>

              <strong>Status</strong>
              <span>
                <Chip
                  label={inv.handoffStatus}
                  size='small'
                  color={inv.handoffStatus === 'success' ? 'primary' : 'secondary'}
                />
              </span>

              <strong>Target ARN</strong>
              <span style={{ wordBreak: 'break-all' }}>{inv.targetArn || '\u2014'}</span>
            </div>

            {inv.handoffError && (
              <div style={{ marginBottom: '1rem' }}>
                <strong>Error</strong>
                <pre
                  style={{
                    background: 'var(--background-grey, #f5f5f5)',
                    padding: '0.75rem',
                    borderRadius: '4px',
                    whiteSpace: 'pre-wrap',
                    wordBreak: 'break-word',
                    fontSize: '0.8125rem',
                    marginTop: '0.25rem',
                    maxHeight: '200px',
                    overflow: 'auto'
                  }}
                >
                  {inv.handoffError}
                </pre>
              </div>
            )}

            {inv.response != null && (
              <div style={{ marginBottom: '1rem' }}>
                <strong>Response</strong>
                <pre
                  style={{
                    background: 'var(--background-grey, #f5f5f5)',
                    padding: '0.75rem',
                    borderRadius: '4px',
                    whiteSpace: 'pre-wrap',
                    wordBreak: 'break-word',
                    fontSize: '0.8125rem',
                    marginTop: '0.25rem',
                    maxHeight: '300px',
                    overflow: 'auto'
                  }}
                >
                  {typeof inv.response === 'string' ? inv.response : JSON.stringify(inv.response, null, 2)}
                </pre>
              </div>
            )}

            {inv.input != null && (
              <div style={{ marginBottom: '1rem' }}>
                <strong>Input Payload</strong>
                <pre
                  style={{
                    background: 'var(--background-grey, #f5f5f5)',
                    padding: '0.75rem',
                    borderRadius: '4px',
                    whiteSpace: 'pre-wrap',
                    wordBreak: 'break-word',
                    fontSize: '0.8125rem',
                    marginTop: '0.25rem',
                    maxHeight: '300px',
                    overflow: 'auto'
                  }}
                >
                  {typeof inv.input === 'string' ? inv.input : JSON.stringify(inv.input, null, 2)}
                </pre>
              </div>
            )}

            <SydModalActions>
              <SydButton variant='primary' size='md' onClick={close}>
                Close
              </SydButton>
            </SydModalActions>
          </>
        )}
      </div>
    </RoundedModal>
  )
})

export default InvocationDetailDialog
